import type { Profile } from '../types/Profile'

export { isProfileIncomplete }

const isProfileIncomplete = (profile?: Profile) =>
  !!profile && (!profile.telefoon.trim() || !profile.rol.trim())
